import { render } from "./Scene.vue?vue&type=template&id=77b55f67"
import script from "./Scene.vue?vue&type=script&lang=js"
export * from "./Scene.vue?vue&type=script&lang=js"

import "./Scene.vue?vue&type=style&index=0&id=77b55f67&lang=scss"
script.render = render

export default script